/**
 * Booth logging.
 *
 * Replaces `@nextinq/device-logger`, which shipped every log line from the
 * device up to the server over the WebSocket. That fed the `applogs`
 * collection — 250 MB of the 485 MB production database, read by nothing. The
 * receive side is gone, so the send side goes with it.
 *
 * Logs now go to the browser console, which is where you look when you are
 * standing at the booth anyway.
 */

export type LogSeverity = 'debug' | 'info' | 'warn' | 'error';

function log(severity: LogSeverity, message: string, args: unknown = {}) {
  // eslint-disable-next-line no-console
  console.log(severity, message, args);
}

export function debug(message: string, args: unknown = {}) {
  log('debug', message, args);
}

export function info(message: string, args: unknown = {}) {
  log('info', message, args);
}

export function warn(message: string, args: unknown = {}) {
  log('warn', message, args);
}

export function error(message: string, args: unknown = {}) {
  log('error', message, args);
}

export function exception(message: string, e: unknown) {
  log('error', message, { exception: e });
}

/**
 * Kept as a no-op so the call site in the socket setup does not need to change
 * shape; there is no longer a socket to attach a log shipper to.
 */
export function initLogger(_ws?: unknown): void {
  /* nothing to initialise */
}

export default { debug, error };
